import { Button, Spinner } from "react-bootstrap";

export default function BotaoComLoading({ onClick, loading, children, ...props }) {
  return (
    <Button onClick={onClick} disabled={loading} {...props}>
      {loading ? (
        <>
          <Spinner
            as="span"
            animation="border"
            size="sm"
            role="status"
            aria-hidden="true"
            className="me-2"
          />
          Carregando...
        </>
      ) : (
        children
      )}
    </Button>
  );
}
